import { escapeRegExp } from "@/utils/regexp";

export const filterMixin = (key) => ({
  data() {
    return {
      [`${key}RegExp`]: null,
      [key]: "",
      filteringMode: "regex",
    };
  },

  computed: {
    filterField() {
      return this.filterByField || "searchText";
    },
    filteredItems() {
      if (!this.searchableItems) {
        console.error("Define a searchableItems property is mandatory to use the filter mixin.");
        return [];
      }
      let filtered = this.searchableItems;
      switch (this.filteringMode) {
        case "regex":
          if (this[`${key}RegExp`]) {
            filtered = filtered.filter(
              (i) =>
                i && i[this.filterField] && String(i[this.filterField]).match(this[`${key}RegExp`])
            );
          }
          break;
        case "startsWith":
          if (this[key]) {
            filtered = filtered.filter(
              (i) => i && i[this.filterField] && String(i[this.filterField]).startsWith(this[key])
            );
          }
          break;
      }

      return filtered;
    },
  },

  watch: {
    [key](value) {
      if (value) {
        this[`${key}RegExp`] = new RegExp(escapeRegExp(value), "gi");
      } else {
        this[`${key}RegExp`] = new RegExp(".*", "gi");
      }
    },
  },

  beforeDestroy() {
    delete this.searchableItems;
  },

  methods: {
    hasMatch(value) {
      if (value && this[key]) {
        return value.match(this[`${key}RegExp`]);
      }
      return false;
    },

    highlight(value) {
      if (value && this[key]) {
        return value.replace(this[`${key}RegExp`], (match) => {
          return `<span class="highlightText">${match}</span>`;
        });
      }
      return value;
    },
  },
});

export default filterMixin("textFilter");
